import { useContext, useEffect, useState } from "react";
import { Client } from "../../../common";
import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { DependencyInjectionContext } from "../../../contexts/dependency-injection-context";

export const ClientSelector = ({ onClientSelected }: {
    onClientSelected: ((clientId: string) => void)
}) => {
    const [clients, setClients] = useState<Client[]>();
    const [selectedClientId, setSelectedClientId] = useState<string>();

    const { formsApi, applicationState } = useContext(DependencyInjectionContext);

    const clientSelected = async (event: any) => {
        const value = event.target.value as string;
        setSelectedClientId(value);
        applicationState.selectedClientId = value;

        onClientSelected(value);
    };

    useEffect(function effectFunction() {
        const getClients = async () => {
            const clients = await applicationState.getClients();
            setClients(clients);

            if (applicationState.selectedClientId == null) {
                setSelectedClientId(clients[0].id);
                applicationState.selectedClientId = clients[0].id;
            } else {
                setSelectedClientId(applicationState.selectedClientId);
            }

            
            onClientSelected(applicationState.selectedClientId || '');
        }

        getClients();
    }, []);

    return (
        <React.Fragment>
            {clients && clients.length > 1 &&
                <form>
                    <FormControl fullWidth className="forms-select">
                        <InputLabel style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            wordWrap: 'break-word',
                            display: 'block',
                            lineHeight: '1em',
                            maxHeight: '2em',
                            maxWidth: '100%',
                            marginTop: '-5px'
                        }}>
                            Select Client
                        </InputLabel>
                        <Select
                            value={selectedClientId}
                            onChange={clientSelected}
                        >
                            {clients?.map(x => {
                                return (
                                    <MenuItem value={x.id} key={x.id}>{x.name}</MenuItem>
                                )
                            })}

                        </Select>
                    </FormControl>
                </form>
            }
        </React.Fragment>
    );
}